export const PerpetualVersionList = [
    1
];

export const PerpetualVersionChoices = PerpetualVersionList.map((x) => { return {'id': x, 'name': x.toString()}; });
